import React from 'react';

import { useTranslation } from 'react-i18next';

import { useNavigationStore } from '@app/store/zustand';

import { NavButton } from '../../NavButton';
import { Toggle } from '../../Toggle';
import { InlineButton } from '../../Toggle/styles';
import { collapseTransition, groupAnimation, itemAnimation } from '../../animations';
import { Buttons, Collapse, Collapseable } from '../../styles';

interface SectionProps {
    isOpen: boolean;
    setIsOpen?: (isOpen: boolean) => void;
    isStatic?: boolean;
}

export const AdminSection = ({ isOpen, setIsOpen, isStatic }: SectionProps) => {
    const [translate] = useTranslation('admin');

    const { toggleAdminOptions, hideAdminOptions } = useNavigationStore((state) => state);

    const handleToggleAdminOptions = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        toggleAdminOptions();
    };

    return (
        <Collapseable>
            <Toggle
                emoji="🚧"
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                isStatic={isStatic}
                aria-expanded={isOpen}
                aria-controls="sidenav-section-admin"
                showWhenOpen={
                    <InlineButton onClick={handleToggleAdminOptions}>
                        {hideAdminOptions ? 'Show Options' : 'Hide Options'}
                    </InlineButton>
                }
            >
                Admin
            </Toggle>

            <Collapse
                variants={groupAnimation}
                initial={false}
                animate={isOpen ? 'open' : 'closed'}
                transition={collapseTransition}
                aria-labelledby="sidenav-section-admin"
            >
                <Buttons>
                    <NavButton to="/admin/users" variants={itemAnimation} newTab>
                        {translate('manage_users')}
                    </NavButton>
                    <NavButton to="/admin/groups" variants={itemAnimation} newTab>
                        {translate('reserve_yats')}
                    </NavButton>
                    <NavButton to="/admin/promo-codes" variants={itemAnimation} newTab>
                        {translate('manage_promo_codes')}
                    </NavButton>
                    <NavButton to="/admin/organizations" variants={itemAnimation} newTab>
                        {translate('manage_organizations')}
                    </NavButton>
                    <NavButton to="/admin/lootboxes" variants={itemAnimation} newTab>
                        Manage Prism Cases
                    </NavButton>
                    <NavButton to="/admin/fantasy" variants={itemAnimation} newTab>
                        Manage Fantasy Wishlists
                    </NavButton>
                </Buttons>
            </Collapse>
        </Collapseable>
    );
};
